export interface TextInput {
  elementName: string;
  idName: string;
  className: string;
  formControlName: string;
  name: string;
  maxLength: number;
  type: string;
  value: string;
  label: string;
  isDisabled: boolean;
  readonly: boolean;
  autocomplete: string;
  placeholder: string;
  onFocus: string;
  onClick: string;
  onEnter: string;
  onBlur: string;
  column: string;
  validation: any[];
}

export interface NumberInput {
  elementName: string;
  idName: string;
  className: string;
  name: string;
  maxlength: number;
  type: string;
  value: string;
  label: string;
  readonly: boolean;
  autocomplete: string;
  placeholder: string;
  onFocus: string;
  onClick: string;
  onBlur: string;
  onEnter: string;
  pattern: string;
  column: string;
  validation: any[];
}

export interface PrimaryButton {
  elementName: string;
  idName: string;
  className: string;
  name: string;
  type: string;
  label: string;
  placeholder: string;
  onFocus: string;
  onClick: string;
  onBlur: string;
  column: string;
  hasPressEnter: boolean;
}

export interface DateFormat {}

export interface Datepicker {
  elementName: string;
  idName: string;
  className: string;
  name: string;
  type: string;
  label: string;
  placeholder: string;
  onFocus: string;
  onClick: string;
  onBlur: string;
  column: string;
  value: string;
  hasPressEnter: boolean;
  dateFormat: DateFormat;
  isAnimated: boolean;
  adaptivePosition: boolean;
  hideOnScroll: boolean;
  returnFocusToInput: boolean;
  selectDateFromOtherMonth: boolean;
  colorTheme: string;
  disableDays: any[];
  disableDates: Date[];
  enableDates: Date[];
  isCalanderDisable: boolean;
  outSideClick: boolean;
  validation: any[];
}

export interface Checkbox {
  elementName: string;
  idName: string;
  className: string;
  name: string;
  type: string;
  label: string;
  value: string;
  checked: boolean;
  onFocus: string;
  onClick: string;
  onBlur: string;
  onEnter: string;
  column: string;
  is_rejection: boolean;
  validation: any[];
}

export interface SelectListInnerElements {
  value: string;
  label: string;
}

export interface SelectList {
  elementName: string;
  idName: string;
  className: string;
  name: string;
  type: string;
  label: string;
  value: string;
  placeholder: string;
  onFocus: string;
  onClick: string;
  onBlur: string;
  readonly: boolean;
  innerelements: SelectListInnerElements[];
  column: string;
  validation: any[];
}

export interface radioBtnInnerElements {
  id: string;
  label: string;
  value: number;
}

export interface RadioButton {
  elementName: string;
  idName: string;
  className: string;
  name: string;
  label: string;
  placeholder: string;
  type: string;
  onFocus: string;
  onClick: string;
  onBlur: string;
  onKeyUp: string;
  column: string;
  value: string;
  innerelements: radioBtnInnerElements[];
  validation: any[];
}

export interface TextArea {
  elementName: string;
  idName: string;
  className: string;
  formControlName: string;
  name: string;
  maxLength: number;
  type: string;
  value: string;
  label: string;
  isDisabled: boolean;
  readonly: boolean;
  rows: number;
  cols: number;
  autocomplete: string;
  placeholder: string;
  onFocus: string;
  onClick: string;
  onEnter: string;
  onBlur: string;
  column: string;
  validation: any[];
}

export interface RadioSwitch {
  elementName: string;
  idName: string;
  className: string;
  formControlName: string;
  name: string;
  type: string;
  label: string;
  value: boolean;
  checked: boolean;
  onFocus: string;
  onClick: string;
  onBlur: string;
  onEnter: string;
  column: string;
  is_rejection: boolean;
  validation: any[];
}
